import { byMedia } from '../helpers/media';
export const alignMap = new Map();
alignMap.set('start', 'flex-start');
alignMap.set('end', 'flex-end');
alignMap.set('center', 'center');
alignMap.set('top', 'flex-start');
alignMap.set('bottom', 'flex-end');
alignMap.set('middle', 'center');
alignMap.set('baseline', 'baseline');
alignMap.set('stretch', 'stretch');
export const alignKeys = ['start', 'end', 'center', 'top', 'bottom', 'middle', 'baseline', 'stretch'];
export const alignContent = byMedia(value => `align-content: ${alignMap.get(value) || value};`);
export const alignItems = byMedia(value => `align-items: ${alignMap.get(value) || value};`);
export const alignSelf = byMedia(value => `align-self: ${alignMap.get(value) || value};`);